import { createRouter, createWebHistory } from 'vue-router'
import connector from '@/utils/Connection'
import store from '@/store'

const routes = [
  {
    path: '/',
    name: 'root',
    meta: {layout: 'main', auth: true, admin: false},
    component: () => import('../views/HomeView.vue'),
  },
  {
    path: '/main',
    name: 'home',
    meta: {layout: 'main', auth: true, admin: false},
    component: () => import('../views/HomeView.vue'),
  },
  {
    path: '/login',
    name: 'login',
    meta: {layout: 'base'},
    component: () => import('../views/Login.vue'),
  },
  {
    path: '/resetpsw',
    name: 'resetpsw',
    meta: {layout: 'base'},
    component: () => import('../views/ResetPasswordView.vue'),
  },
  {
    path: '/register',
    name: 'register',
    meta: {layout: 'base'},
    component: () => import('../views/Register.vue'),
  },
  {
    path: '/docs',
    name: 'documents',
    meta: {layout: 'main', auth: true, admin: false},
    component: () => import('../views/Documents.vue'),
  },
  {
    path: '/history',
    name: 'history',
    meta: {layout: 'main', auth: true, admin: false},
    component: () => import('../views/History.vue'),
  },
  {
    path: '/appointmentsPractice',
    name: 'appointmentsPractice',
    meta: {layout: 'main', auth: true, admin: false},
    component: () => import('../views/AppointmentsPractice.vue'),
  },
  {
    path: '/appointmentsDoctor',
    name: 'appointmentsDoctor',
    meta: {layout: 'main', auth: true, admin: false},
    component: () => import('../views/AppointmentsDoctor.vue'),
  },
  {
    path: '/nalog',
    name: 'taxdocuments',
    meta: {layout: 'main', auth: true, admin: false},
    component: () => import('../views/TaxDocuments.vue'),
  },
  {
    path: '/consultation',
    name: 'consultation',
    meta: {layout: 'main', auth: true, admin: false},
    component: () => import('../views/OnlineCunsultation.vue'),
  },
  {
    path: '/director',
    name: 'director',
    meta: {layout: 'main', auth: true, admin: false},
    component: () => import('../views/DirectorMessage.vue'),
  },
  {
    path: '/info',
    name: 'info',
    meta: {layout: 'main', auth: true, admin: false},
    component: () => import('../views/Information.vue'),
  },
  {
    path: '/confirm',
    name: 'confirm',
    meta: {layout: 'base'},
    component: () => import('../views/ConfirmRegistration.vue'),
  },  
  // admin routes
  {
    path: '/adminmain',
    name: 'adminhome',
    meta: {layout: 'admin', auth: true, admin: true},
    //component: () => import('../views/admin/AdminHomeView.vue'),
    component: () => import('../views/admin/Users.vue'),
  },
  {
    path: '/users',
    name: 'users',
    meta: {layout: 'admin', auth: true, admin: true},
    component: () => import('../views/admin/Users.vue'),
  },
  {
    path: '/userrequests',
    name: 'userrequests',
    meta: {layout: 'admin', auth: true, admin: true},
    component: () => import('../views/admin/UsersForConfirm.vue'),
  },
  {
    path: '/patients',
    name: 'allpatients',
    meta: {layout: 'admin', auth: true, admin: true},
    component: () => import('../views/admin/PatientsList.vue'),
  },
  {
    path: '/doctors',
    name: 'doctors',
    meta: {layout: 'admin', auth: true, admin: true},
    component: () => import('../views/admin/DoctorsList.vue'),
  },
  {
    path: '/admappointments',
    name: 'admappointments',
    meta: {layout: 'admin', auth: true, admin: true},
    component: () => import('../views/admin/AppointmentsList.vue'),
  },
  {
    path: '/changepwd',
    name: 'changepwd',
    meta: {layout: 'base'},
    component: () => import('../views/ChangePasswordView.vue'),
  },
  {
    path: '/appointment',
    name: 'appointment',
    meta: {layout: 'base'},
    component: () => import('../views/Appointment.vue'),
  },
  {
    path: '/regappointment',
    name: 'regappointment',
    meta: {layout: 'main', auth: true, admin: false},
    component: () => import('../views/Appointment.vue'),
  },
  {
    path: '/appointmentconfirm',
    name: 'appointmentconfirm',
    meta: {layout: 'main', auth: true, admin: false},
    component: () => import('../views/AppointmentConfirm.vue'),
  },
  {
    path: '/profile',
    name: 'profile',
    meta: {layout: 'main', auth: true, admin: false},
    component: () => import('../views/Profile.vue'),
  },
  {
    path: '/addpatient',
    name: 'addpatient',
    meta: {layout: 'main', auth: true, admin: false},
    component: () => import('../views/AddPatient.vue'),
  },
] 

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next)=>{
  const requireAuth = to.matched.some(r => r.meta.auth);
  const requireAdm = to.matched.some(r => r.meta.admin);
  let isAdmin = store.getters.getIsAdmin;
  //console.log('router - ', store.getters.getIsAdmin);
  //console.log('userId - ', store.getters.getUserId);
  //console.log('connector - ', !connector.connected);
  //console.log('appointment - ', store.getters.getAppointmentsDateTime);
  if (requireAuth){
    //console.log('Авторизован - ',connector.connected);
    if (!connector.connected){
      const authResult = await store.dispatch('login', {userPhone: '', password: ''});
      isAdmin = store.getters.getIsAdmin;
      if (authResult.error == 0 && requireAdm <= isAdmin) {
        next();
      } else {
        next('/login');
      } 
    } else {
      if (requireAdm <= isAdmin){
        if (to.path == '/main' && (from.path == '/login' || from.path == '/confirm') 
            && store.getters.getAppointmentDateTime) {
          next('/appointmentconfirm');
        } else {
          next();
        }          
      } else {
        next('/login');
      }        
    }
  } else {
    next();
  }
});

export default router;
